<h2 mat-dialog-title>
  {{ "reuseConfirmDialog.Confirmation" | translate }}
</h2>
<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <p [innerHTML]="'reuseConfirmDialog.MsgEditText' | translate"></p>
  <p>{{ "reuseConfirmDialog.MsgProceed" | translate }}</p>
</div>
<div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions fxFlex fxLayoutAlign="center center">
    <button mat-button color="primary" [mat-dialog-close]="false">{{ "reuseConfirmDialog.No" | translate }}</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">{{ "reuseConfirmDialog.Yes" | translate }}</button>
  </mat-dialog-actions>
</div>
